import React from 'react';
import Avatar from '@mui/material/Avatar';
import FaceIcon from '@mui/icons-material/Face';

/**
 * PersonAvatar - Displays a person's avatar with fallback to FaceIcon
 * @param {string} imageUrl - URL of the person's image
 * @param {string} name - Person's name (for alt text)
 * @param {number} size - Avatar size in pixels (default: 64)
 */
export default function PersonAvatar({ imageUrl, name = 'Unknown', size = 64 }) {
  const iconSize = Math.round(size * 0.625); // Icon is ~62.5% of avatar size

  return imageUrl ? (
    <Avatar
      src={imageUrl}
      alt={name}
      sx={{ width: size, height: size, mr: 2 }}
    />
  ) : (
    <Avatar sx={{ width: size, height: size, mr: 2 }}>
      <FaceIcon sx={{ fontSize: iconSize }} />
    </Avatar>
  );
}
